export function LandingAlerts() {
  return (
    <section id="alerts" className="scroll-mt-20 border-t border-border py-32 md:py-40">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 max-w-3xl">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
            Alerts
          </p>
          <h2 className="mb-6 text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            Notifications tuned to the yachts and competitors you actually care about.
          </h2>
          <p className="text-base text-muted-foreground md:text-lg">
            Every competitor in your set, every yacht in your fleet, gets its own alert rules.
            Choose the moves that matter (price drops, sold-out weeks, new listings, discount
            changes) and the channels you want them in: instant push, daily digest, Slack, or email.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-[2fr_1fr]">
          <AlertsMock />
          <AlertChannels />
        </div>
      </div>
    </section>
  );
}

function AlertsMock() {
  const events = [
    { when: '08:42', text: 'Adriatic Wind dropped Jul 6 by 4.2% (€4,110 → €3,940)', tag: 'price' },
    { when: '07:13', text: 'Lavanda: Aug 17 week sold out', tag: 'availability' },
    { when: 'Yesterday', text: '6 boats moved prices in Split base. Digest sent.', tag: 'digest' },
    { when: '2 days ago', text: 'Mistral moved up 2.5% across Aug peak', tag: 'price' },
    { when: '3 days ago', text: 'New listing in your set: Hanse 458 · "Polaris"', tag: 'new' },
  ];
  return (
    <ul className="divide-y divide-border rounded-lg border border-border bg-background">
      {events.map((event) => (
        <li
          key={`${event.when}-${event.text}`}
          className="flex items-start gap-4 px-4 py-3 text-sm"
        >
          <span className="font-mono tabular-nums text-xs text-muted-foreground w-24 shrink-0">
            {event.when}
          </span>
          <span className="flex-1 text-foreground">{event.text}</span>
          <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            {event.tag}
          </span>
        </li>
      ))}
    </ul>
  );
}

function AlertChannels() {
  const channels = [
    { name: 'Email', detail: 'Daily digest at 09:00' },
    { name: 'Slack', detail: 'Instant on price drops > 5%' },
    { name: 'In-app', detail: 'All events, real-time' },
    { name: 'Webhook', detail: 'Pipe into your stack' },
  ];
  return (
    <div className="rounded-lg border border-border bg-background p-5">
      <p className="mb-4 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
        Channels
      </p>
      <ul className="space-y-3">
        {channels.map((channel) => (
          <li key={channel.name} className="flex items-baseline justify-between gap-4">
            <span className="text-sm font-medium text-foreground">{channel.name}</span>
            <span className="text-xs text-muted-foreground">{channel.detail}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
